import { render, staticRenderFns } from "./best-plans.vue?vue&type=template&id=6bda34ca&scoped=true&lang=pug&"
import script from "./best-plans.vue?vue&type=script&lang=js&"
export * from "./best-plans.vue?vue&type=script&lang=js&"
import style0 from "./best-plans.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./best-plans.vue?vue&type=style&index=1&id=6bda34ca&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bda34ca",
  null
  
)

export default component.exports